/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate new password`)
};

const es_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar nueva contraseña`)
};

const de_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort generieren`)
};

const nl_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer nieuw wachtwoord`)
};

const fr_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer un nouveau mot de passe`)
};

const it_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera nuova password`)
};

const pt_br2_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar nova senha`)
};

const pt_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar nova senha`)
};

const ja_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいパスワードを生成`)
};

const zh_pw_generate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成新密码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_generate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_generate(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_generate", locale)
	if (locale === "en") return en_pw_generate(inputs)
	if (locale === "es") return es_pw_generate(inputs)
	if (locale === "de") return de_pw_generate(inputs)
	if (locale === "nl") return nl_pw_generate(inputs)
	if (locale === "fr") return fr_pw_generate(inputs)
	if (locale === "it") return it_pw_generate(inputs)
	if (locale === "pt-BR") return pt_br2_pw_generate(inputs)
	if (locale === "pt") return pt_pw_generate(inputs)
	if (locale === "ja") return ja_pw_generate(inputs)
	return zh_pw_generate(inputs)
};